import React, { useState } from 'react';
import { Card, Badge, Button, Modal, Form } from 'react-bootstrap';

const InterestedGroupCard = ({ group, onMatch, onDismiss }) => {
  const [showMatchModal, setShowMatchModal] = useState(false);
  const [message, setMessage] = useState('');

  const handleInterested = () => {
    setShowMatchModal(true);
  };

  const handleSendMessage = () => {
    onMatch(group.id, message);
    setShowMatchModal(false);
  };

  const handleSkipMessage = () => {
    onMatch(group.id, null);
    setShowMatchModal(false);
  };

  return (
    <>
      <Card className="mb-3 shadow-sm">
        <Card.Body>
          <Card.Title className="d-flex justify-content-between align-items-center">
            <span>{group.name}</span>
            <Badge bg="success">Interested in you</Badge>
          </Card.Title>
          <Card.Text>
            <strong>Location:</strong> {group.location}<br />
            <strong>Setting:</strong> {group.settings.join(', ')}<br />
            <strong>Rate:</strong> ${group.rate}/hr<br />
            <strong>Schedule:</strong> {group.schedule}
          </Card.Text>
          <div className="d-flex gap-2 justify-content-end">
            <Button variant="outline-danger" onClick={() => onDismiss(group.id)}>
              👎 Not Interested
            </Button>
            <Button variant="primary" onClick={handleInterested}>
              👍 I'm Interested
            </Button>
          </div>
        </Card.Body>
      </Card>

      <Modal show={showMatchModal} onHide={() => setShowMatchModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>🎉 It's a Match!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>You're now connected with <strong>{group.name}</strong>.</p>
          <Form.Group>
            <Form.Label>Send a message:</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={message}
              placeholder="Ask about onboarding, schedule, etc."
              onChange={(e) => setMessage(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSkipMessage}>
            Skip
          </Button>
          <Button variant="primary" onClick={handleSendMessage}>
            Send Message
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default InterestedGroupCard;
